<template>

	<div :class="{'hide': loading}">
		<div :class="{'spinner loading': loading}"></div>

		<div class="prices">
			<pricing-table></pricing-table>
			<div class="service-list column4-wrap" style="margin: 25px auto">

				<div v-if="$config.type !== 'white'">
					<!-- SERVICE ITEM -->
					<div class="service-item standard column">
						<div class="image"><img src="/images/icons/revision.svg"></div>
						<h3>Free Revisions</h3>
						<p>No need to pay additionally for correction of your paper: have your work revised in any case and at any time for free.</p>
					</div>
					<!-- /SERVICE ITEM -->
					<!-- SERVICE ITEM -->
					<div class="service-item standard column">
						<div class="image"><img src="/images/icons/references.svg"></div>
						<h3>Free References</h3>
						<p>No need to pay additionally for sources that have to be used: our writers will have it all covered for you for free.</p>
					</div>
					<!-- /SERVICE ITEM -->

					<!-- SERVICE ITEM -->
					<div class="service-item standard column">
						<div class="image"><img src="/images/icons/format.svg"></div>
						<h3>Free Formatting</h3>
						<p>No need to pay additionally for specific formatting of your papers: our writers will do a proper formatting for free.</p>
					</div>
					<!-- /SERVICE ITEM -->
					<!-- SERVICE ITEM -->
					<div class="service-item standard column">
						<div class="image"><img src="/images/icons/title-page.svg"></div>
						<h3>Free title page</h3>
						<p>No need to pay additionally for the title page: it comes together with your entire paper absolutely for free.</p>
					</div>
					<!-- /SERVICE ITEM -->
				</div>
			</div>
			<div class="clearfix"></div>
			<!--<a href="/order" class="button big dark" style="margin: 80px auto 0; background: #ffa312;">Order now</a>-->

		</div>

	</div>
</template>


<script>

    export default {

        props: ['order'],
        data() {
            return {

            }
        },

        created(){
            this.loading = false;

        },

    }
</script>